import React from 'react';
import { Box, Container, Typography, Card, CardContent, useTheme, alpha, Chip, Grid } from '@mui/material';
import { ILogo } from '../../styles/components/ILogo';
import RoadmapCanvas from './RoadmapCanvas';

const RoadmapBuilder: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: `linear-gradient(45deg, ${alpha(theme.palette.primary.main, 0.05)}, ${alpha(theme.palette.secondary.main, 0.05)})`,
        py: 4,
      }}
    >
      <Container maxWidth="md">
        {/* Brand Logo */}
        <Grid sx={{ paddingTop: 2, alignContent: 'center' }}>
          <center>
            <ILogo src="/assets/Single_mainlogo_tm.svg" />
          </center>
        </Grid>

        {/* Title */}
        <Typography
          variant="h3"
          align="center"
          gutterBottom
          sx={{
            fontWeight: 700,
            background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            backgroundClip: 'text',
            textFillColor: 'transparent',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            mb: 2,
            mt: 2,
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: -12,
              left: '50%',
              transform: 'translateX(-50%)',
              width: 80,
              height: 3,
              background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
              borderRadius: 2,
            },
          }}
        >
          Roadmap Builder
        </Typography>

        {/* Kind Message */}
        <Card
          sx={{
            mt: 4,
            mb: 4,
            background: `linear-gradient(135deg, ${alpha('#FFD700', 0.1)}, ${alpha(theme.palette.success.main, 0.1)})`,
            border: `1px solid ${alpha('#FFD700', 0.3)}`,
            borderRadius: '15px',
            overflow: 'hidden',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '3px',
              background: `linear-gradient(90deg, #FFD700, ${theme.palette.success.main}, #FFD700)`,
            },
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <Box sx={{ textAlign: 'center', mb: 2 }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  background: `linear-gradient(45deg, #FFD700, ${theme.palette.success.main})`,
                  backgroundClip: 'text',
                  textFillColor: 'transparent',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  mb: 1,
                }}
              >
                💛 Donate Back – Not Just Money
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: theme.palette.text.secondary,
                  mb: 1,
                }}
              >
                If Release Pilot boosted your productivity by 0.1%—give back through <strong>impact, not money</strong> 🌟
              </Typography>
            </Box>
            <Box 
              sx={{ 
                display: 'flex', 
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: 1,
                mb: 2,
              }}
            >
              {['🤝 Help others', '👥 Mentor fellow developer', '🚀 Share opportunities', '💡 Contribute skills', '❤️ Spread kindness'].map((item, index) => (
                <Chip
                  key={index}
                  label={item}
                  variant="outlined"
                  size="small"
                  sx={{
                    borderColor: alpha('#FFD700', 0.5),
                    color: theme.palette.text.primary,
                    '&:hover': {
                      backgroundColor: alpha('#FFD700', 0.1),
                      transform: 'scale(1.02)',
                    },
                  }}
                />
              ))}
            </Box>
            <Typography 
              variant="body2" 
              sx={{ 
                textAlign: 'center',
                color: theme.palette.text.secondary,
                fontStyle: 'italic',
              }}
            >
              Every small action matters. Let your gratitude become someone else's breakthrough. 🙌
            </Typography>
          </CardContent>
        </Card>

        {/* Crafted with Love */}
        <Typography 
          variant="body1" 
          sx={{ 
            textAlign: 'center',
            color: theme.palette.text.secondary,
            mt: 3,
            mb: 2,
            fontSize: '1.1rem',
          }}
        >
          Crafted with ❤️ in India
        </Typography>

        {/* Roadmap Canvas */}
        <RoadmapCanvas />
      </Container>
    </Box>
  );
};

export default RoadmapBuilder; 